import React from 'react'
import {makeStyles} from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import gomunityLogo from './assets/gomunity_logo.png'

const useStyles = makeStyles(theme => ({
  card: {
    padding: theme.spacing(3),
    borderRadius: '16px',
    background: 'linear-gradient(135deg, #fbf7ef 0%, #f5eee0 100%)',
    border: '1px solid #e6dcc6',
    boxShadow:
      '0 1px 2px rgba(0, 0, 0, 0.04), 0 12px 28px -16px rgba(140, 109, 63, 0.45)',
  },
  logo: {
    display: 'block',
    height: '40px',
    width: 'auto',
    objectFit: 'contain',
    marginBottom: theme.spacing(2),
  },
  title: {
    fontWeight: 700,
    fontSize: '1.125rem',
    lineHeight: 1.35,
    color: '#3b2f17',
  },
  text: {
    marginTop: theme.spacing(0.5),
    color: '#3b2f17',
  },
}))

export default function MembershipLoginSuccessMessage({name}) {
  const classes = useStyles()

  return (
    <div className={classes.card}>
      {/* Logo decorativo: il nome Gomunity e' gia' nel testo sotto, quindi
          un alt lo farebbe annunciare due volte dallo screen reader. */}
      <img className={classes.logo} src={gomunityLogo} alt="" />

      <Typography component="p" className={classes.title}>
        Ciao {name}, Gomunity ti dà il benvenuto.
      </Typography>

      <Typography variant="body2" className={classes.text}>
        Puoi procedere alla prenotazione del tuo pacchetto.
      </Typography>
    </div>
  )
}
